import React, { useState, useRef, useCallback, useEffect } from 'react';
import './TransposeCapo.css';
import { capoLabel, suggestCapo } from '../utils/chordTranspose';

const CAPO_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function TransposeCapo({ transposition, capo, onTranspose, onCapoChange, songKey }) {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const popoverRef = useRef();

  const suggestions = songKey ? suggestCapo(songKey) : [];

  const handleClickOutside = useCallback((e) => {
    if (popoverRef.current && !popoverRef.current.contains(e.target)) {
      setShowSuggestions(false);
    }
  }, []);

  useEffect(() => {
    if (showSuggestions) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showSuggestions, handleClickOutside]);

  return (
    <div className="transpose-capo">
      <div className="transpose-capo__group">
        <span className="transpose-capo__label">Transpose</span>
        <div className="transpose-capo__controls">
          <button
            className="tc-btn"
            onClick={() => onTranspose(transposition - 1)}
            aria-label="Transpose down"
          >−</button>
          <span className="tc-value">
            {transposition === 0 ? '0' : (transposition > 0 ? `+${transposition}` : transposition)}
          </span>
          <button
            className="tc-btn"
            onClick={() => onTranspose(transposition + 1)}
            aria-label="Transpose up"
          >+</button>
        </div>
      </div>

      <div className="transpose-capo__group" ref={popoverRef} style={{ position: 'relative' }}>
        <span className="transpose-capo__label">Capo</span>
        <div className="transpose-capo__controls">
          <select
            className="tc-select"
            value={capo}
            onChange={e => onCapoChange(Number(e.target.value))}
            aria-label="Select capo fret"
          >
            {CAPO_OPTIONS.map(fret => (
              <option key={fret} value={fret}>{capoLabel(fret)}</option>
            ))}
          </select>
          {suggestions.length > 0 && (
            <button
              className="tc-btn tc-btn--suggest"
              onClick={() => setShowSuggestions(v => !v)}
              title="Suggest capo for guitar-friendly keys"
            >
              💡
            </button>
          )}
        </div>
        {showSuggestions && suggestions.length > 0 && (
          <div className="tc-suggestions">
            <div className="tc-suggestions__title">Capo suggestions for {songKey}</div>
            {suggestions.map(s => (
              <button
                key={s.capo}
                className={`tc-suggestion-item${s.capo === capo ? ' active' : ''}`}
                onClick={() => { onCapoChange(s.capo); setShowSuggestions(false); }}
              >
                {s.display}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TransposeCapo;
